import {
    getApiErrorMessage,
    getFormMode,
    getRecordFromResponse,
    validateSchemaFields
} from 'lib/formUtils';
import {
    Box,
    CardContent,
    TextField,
    Typography
} from '@material-ui/core';
import api from 'services/api';
import PropTypes from 'prop-types';
import { ANAO, ASIM } from 'consts';
import React, { Component } from 'react';
import { AlertInformation } from 'components';
import { safeSetState } from 'lib/reactUtils';
import { FormActions, FormStatusSwitch } from 'views/Components';

class UnidadeForm extends Component {
    _isMounted = false;
    safeSetState = safeSetState;

    state = {
        isNewRecord: false,
        isView: false,
        unidade: {
            codunidade: '',
            descunidade: '',
            abreviatura: '',
            inativo: ANAO
        },
        openAlert: false,
        messageAlert: '',
        errors: {},
        schema: {
            descunidade: {
                presence: {
                    allowEmpty: false,
                    message: 'Descrição da unidade obrigatória'
                },
                length: { maximum: 50 },
                type: 'string'
            },
            abreviatura: {
                presence: {
                    allowEmpty: false,
                    message: 'Abreviatura da unidade obrigatória'
                },
                length: { maximum: 10 },
                type: 'string'
            }
        }
    };

    /* Carrega os dados iniciais da tela */
    async componentDidMount() {
        this._isMounted = true;

        const {
            id,
            isNewRecord,
            isView
        } = getFormMode(this.props.match, this.props.location);

        try {
            if (isNewRecord) {
                this.setState({
                    isNewRecord: true,
                    isView: false,
                    unidade: this.getUnidadeDefault()
                });

                return;
            }

            if (!isNaN(Number(id))) {
                await this.loadUnidade(id, isView);
            }
        } catch (error) {
            console.error(
                'Erro ao carregar unidade:',
                error.response?.data || error.message
            );

            this.handleOpenAlert(
                getApiErrorMessage(
                    error,
                    'Erro ao carregar unidade!'
                )
            );
        }
    };

    /* Limpa a flag de montagem ao sair da tela */
    componentWillUnmount() {
        this._isMounted = false;
    };

    /* Retorna a unidade padrão */
    getUnidadeDefault = () => ({
        codunidade: '',
        descunidade: '',
        abreviatura: '',
        inativo: ANAO
    });

    /* Carrega a unidade */
    loadUnidade = async (id, isView) => {
        const { history } = this.props;

        const response = await api.get(`/unidade/${id}`);
        const registro = getRecordFromResponse(response);

        if (!registro) {
            this.handleOpenAlert('Unidade não encontrada!');

            history.push('/estoque/unidade');

            return;
        }

        this.safeSetState({
            unidade: {
                codunidade: registro.codunidade || '',
                descunidade: registro.descunidade || '',
                abreviatura: registro.abreviatura || '',
                inativo: registro.inativo || ANAO
            },
            isNewRecord: false,
            isView
        });
    };

    /* Evento onChange componentes */
    onChange = (event) => {
        const { name, type, value, checked } = event.target;

        const adjustedValue = type === 'checkbox'
            ? (checked ? ANAO : ASIM)
            : typeof value === 'string' ? value.toUpperCase() : value;

        this.setState(prevState => ({
            unidade: {
                ...prevState.unidade,
                [name]: adjustedValue
            }
        }));
    };

    /* Abre a janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.safeSetState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* Fecha a janela de mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Retorna o payload de unidade */
    getPayloadUnidade = () => {
        const { unidade } = this.state;

        return {
            descunidade: unidade.descunidade || '',
            abreviatura: unidade.abreviatura || '',
            inativo: unidade.inativo || ANAO
        };
    };

    /* Clicar para salvar */
    onClickSave = async () => {
        const { unidade, isNewRecord } = this.state;
        const { history, loadUnidade } = this.props;

        const errors = this.validationRequiredFields();
        this.setState({ errors });

        if (Object.keys(errors).length > 0) {
            this.handleOpenAlert('Verifique os campos obrigatórios!');

            return;
        }

        try {
            const payload = this.getPayloadUnidade();

            if (isNewRecord) {
                await api.post('/unidade', payload);
            } else {
                await api.put(`/unidade/${unidade.codunidade}`, payload);
            }

            if (loadUnidade) loadUnidade();

            history.push('/estoque/unidade');
        } catch (error) {
            console.error('Erro ao salvar:', error.response?.data || error.message);

            this.handleOpenAlert(
                getApiErrorMessage(
                    error,
                    'Erro ao salvar!'
                )
            );
        }
    };

    /* Clicar para cancelar */
    onClickCancel = () => {
        this.props.history.push('/estoque/unidade');
    };

    /* Valida os campos obrigatórios ao salvar */
    validationRequiredFields() {
        const { unidade, schema } = this.state;

        return validateSchemaFields(
            unidade,
            schema,
            [
                'descunidade',
                'abreviatura'
            ]
        );
    };

    render() {
        const {
            errors,
            isView,
            messageAlert,
            openAlert,
            unidade
        } = this.state;

        return (
            <div>
                <CardContent>
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        style={{ flexWrap: 'wrap' }}
                    >
                        <Typography
                            component="h1"
                            variant="h3"
                        >
                            Unidade {unidade.codunidade}
                        </Typography>

                        <FormStatusSwitch
                            checked={unidade.inativo !== ASIM}
                            name="inativo"
                            onChange={this.onChange}
                            disabled={isView}
                        />
                    </Box>

                    <br />

                    <Box
                        display="flex"
                        flexWrap="wrap"
                        style={{ gap: 12 }}
                    >
                        <TextField
                            label="Descrição"
                            name="descunidade"
                            value={unidade.descunidade || ''}
                            variant="outlined"
                            onChange={this.onChange}
                            helperText={errors.descunidade || ''}
                            error={!!errors.descunidade}
                            disabled={isView}
                            inputProps={{ maxLength: 50 }}
                            style={{
                                flex: 2,
                                minWidth: 220
                            }}
                        />

                        <TextField
                            label="Abreviatura"
                            name="abreviatura"
                            value={unidade.abreviatura || ''}
                            variant="outlined"
                            onChange={this.onChange}
                            helperText={errors.abreviatura || 'Ex.: KG, MT'}
                            error={!!errors.abreviatura}
                            disabled={isView}
                            inputProps={{ maxLength: 10 }}
                            style={{
                                flex: 1,
                                minWidth: 140
                            }}
                        />
                    </Box>

                    <br />
                    <br />

                    <FormActions
                        onSave={this.onClickSave}
                        onCancel={this.onClickCancel}
                        disableSave={isView}
                    />
                </CardContent>

                <AlertInformation
                    open={openAlert}
                    message={messageAlert}
                    handleClose={this.handleCloseAlert}
                />
            </div>
        );
    }
};

UnidadeForm.propTypes = {
    history: PropTypes.object,
    match: PropTypes.object,
    location: PropTypes.object,
    loadUnidade: PropTypes.func
};

export default UnidadeForm;